<template>
    <div class="p-4 bg-white rounded border-2 border-green-500 shadow">
        <div v-if="active" class="space-y-4">
            <div class="text-xl">Your listing is active and visible to people looking for firewood until <span class="font-medium">{{ localActiveUntil }}</span>.</div>
            <div class="text-xl">To keep your listing active, all you have to do is log in to Firewood Match. Your listing will be extended 30 days out from each time you log in.</div>
        </div>

        <div v-else class="space-y-4">
            <div class="text-xl">Your listing is currently inactive and won't be visible to people looking for firewood.</div>
            <div class="text-xl">To activate your listing, click the toggle just above.</div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import emitter from 'tiny-emitter/instance';
export default {
    props: {
        initialActive: {
            type: Boolean,
            required: true
        },
        initialActiveUntil: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            active: this.initialActive,
            activeUntil: this.initialActiveUntil,
        }
    },
    computed: {
        localActiveUntil() {
            return dayjs(this.activeUntil).format('dddd, MMM D, YYYY')
        }
    },
    created() {
        emitter.on('activated', ({ active, activeUntil }) => {
            this.active = active
            this.activeUntil = activeUntil
        })

        emitter.on('deactivated', ({ active }) => {
            this.active = active
        })
    }
}
</script>
